import React from 'react';
import ProfileShell from '../../components/forms/ProfileShell';
import { SectionHeader, Field, Input, Select, Toggle, TextArea } from '../../components/forms/FormPrimitives';

const RENTAL_TYPES = ['Apartment', 'House', 'Condo', 'Townhome'];
const DEDUCTIBLES = ['$250', '$500', '$1,000', '$2,500', 'Not sure yet'];
const PROPERTY_VALUES = ['Under $10,000', '$10,000 – $25,000', '$25,000 – $50,000', '$50,000 – $100,000', '$100,000+', 'Not sure yet'];

const RentersProfile = () => {
  const sections = [
    {
      title: 'Rental Information',
      render: (data, update) => (
        <div>
          <SectionHeader index={1} title="Rental Information" subtitle="Tell us about your rental." />
          <Field label="Rental Address" testid="rent-address">
            <Input value={data.rental_address} onChange={(v) => update({ rental_address: v })} placeholder="123 Main St, Apt 4, Dallas, TX" />
          </Field>
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            <Field label="Type of Rental" testid="rent-type">
              <Select value={data.rental_type} onChange={(v) => update({ rental_type: v })} options={RENTAL_TYPES} />
            </Field>
            <Field label="Move-in Date (if applicable)" testid="rent-movein">
              <Input type="date" value={data.move_in_date} onChange={(v) => update({ move_in_date: v })} />
            </Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Personal Property / Liability',
      render: (data, update) => (
        <div>
          <SectionHeader index={2} title="Personal Property / Liability" subtitle="Help us size your coverage." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Estimated Personal Property Value" testid="rent-value">
              <Select value={data.property_value} onChange={(v) => update({ property_value: v })} options={PROPERTY_VALUES} />
            </Field>
            <Field label="Desired Deductible" testid="rent-deductible">
              <Select value={data.deductible} onChange={(v) => update({ deductible: v })} options={DEDUCTIBLES} />
            </Field>
          </div>
          <div className="space-y-3 mt-4">
            <Toggle value={data.need_liability} onChange={(v) => update({ need_liability: v })} label="I need liability coverage" testid="rent-liability" />
            <Toggle value={data.has_high_value_items} onChange={(v) => update({ has_high_value_items: v })} label="I have high-value items (jewelry, electronics, instruments, etc.)" testid="rent-high-value" />
          </div>
          {data.has_high_value_items && (
            <Field label="Describe high-value items" testid="rent-high-value-desc">
              <TextArea value={data.high_value_items_desc} onChange={(v) => update({ high_value_items_desc: v })} placeholder="e.g. Engagement ring, MacBook Pro" />
            </Field>
          )}
        </div>
      ),
    },
    {
      title: 'Current / Bundle Options',
      render: (data, update) => (
        <div>
          <SectionHeader index={3} title="Current Insurance & Bundle Options" subtitle="Almost done — these may unlock discounts." />
          <Field label="Current Carrier" testid="rent-carrier">
            <Input value={data.current_carrier} onChange={(v) => update({ current_carrier: v })} placeholder="If any" />
          </Field>
          <div className="space-y-3 mt-4">
            <Toggle value={data.bundle_auto} onChange={(v) => update({ bundle_auto: v })} label="Interested in bundling auto insurance" testid="rent-bundle" />
            <Toggle value={data.has_pets} onChange={(v) => update({ has_pets: v })} label="I have pets" testid="rent-pets" />
          </div>
          <Field label="Claims in past 5 years?" testid="rent-claims">
            <Select value={data.claims_5y} onChange={(v) => update({ claims_5y: v })} options={['None', '1', '2', '3+']} />
          </Field>
          <Field label="Anything else we should know?" testid="rent-notes">
            <TextArea value={data.profile_notes} onChange={(v) => update({ profile_notes: v })} />
          </Field>
        </div>
      ),
    },
  ];

  return (
    <ProfileShell
      coverageType="renters"
      sections={sections}
      personalTouchMessage="Renters insurance protects your belongings and provides liability coverage at an affordable cost. Complete what you can — we'll guide you."
    />
  );
};

export default RentersProfile;
